import Api from '@/vuex/api'
import {
  DELETE_COMPANY,
  DELETE_COMPANY_MANAGER,
  EDIT_COMPANY,
  EDIT_COMPANY_MANAGER,
  EDIT_MASTER_NOTE,
  LOAD_COMPANY,
  LOAD_COMPANY_CONTRACTORS,
  LOAD_COMPANY_MANAGERS,
  LOAD_COMPANY_PROPERTIES,
  NEW_COMPANY_MANAGER,
  NEW_CONTRACTOR,
  NEW_PROPERTY,
  NEW_PROPERTY_EXCEL,
  OPEN_CONFIRMATION_MODAL,
  OPEN_MODAL,
  GENERATE_ACCEPTANCE_RATE_REPORT,
  EDIT_ACCEPTANCE_RATE_REPORT,
  GENERATE_COMPANY_ACCEPTANCE_RATE_REPORT,
  EDIT_COMPANY_ACCEPTANCE_RATE_REPORT,
  GENERATE_ALL_COMPANY_STATS,
  VIEW_ALL_COMPANY_STATS
} from '@/vuex/types'

const api = new Api()
const state = {
  company: {
    uuid: '',
    Accounts: [],
    accountsTotal: 0,
    accountsColumns: [],
    Properties: [],
    propertiesColumns: [],
    propertiesTotal: 0,
    Contractors: [],
    contractorsTotal: 0,
    contractorsColumns: []
  },
  companyActions: [
    { label: 'Edit Company', command: EDIT_COMPANY, icon: 'fa fa-edit' },
    { label: 'Edit Master Note', command: EDIT_MASTER_NOTE, icon: 'fa fa-sticky-note' },
    { label: 'Delete Company', command: DELETE_COMPANY, icon: 'fa fa-trash' }
  ]
}

const mutations = {
  [LOAD_COMPANY] (state, company) {
    state.company = { ...state.company, ...company }
  },
  [LOAD_COMPANY_MANAGERS] (state, managers) {
    state.company.Accounts = managers.rows
    state.company.accountsTotal = managers.count
    state.company.accountsColumns = managers.columns
  },
  [LOAD_COMPANY_PROPERTIES] (state, properties) {
    state.company.Properties = properties.rows
    state.company.propertiesColumns = properties.columns
    state.company.propertiesTotal = properties.count
  },
  [LOAD_COMPANY_CONTRACTORS] (state, properties) {
    state.company.Contractors = properties.rows
    state.company.contractorsTotal = properties.count
    state.company.contractorsColumns = properties.columns
  }
}

const getters = {
  companyActions ({ companyActions }) {
    return companyActions
  },
  loadedCompany ({ company }) {
    return company
  },
  companyManagers ({ company }) {
    return company.Accounts
  },
  companyManagersTotal ({ company }) {
    return company.accountsTotal
  },
  companyManagersColumns ({ company }) {
    return company.accountsColumns
  },
  companyProperties ({ company }) {
    return company.Properties
  },
  companyPropertiesTotal ({ company }) {
    return company.propertiesTotal
  },
  companyPropertiesColumns ({ company }) {
    return company.propertiesColumns
  },
  companyContractors ({ company }) {
    return company.Contractors
  },
  companyContractorsTotal ({ company }) {
    return company.contractorsTotal
  },
  companyContractorsColumns ({ company }) {
    return company.contractorsColumns
  }
}

const actions = {
  async [DELETE_COMPANY] (context, company) {
    let deleteCompanyModal = {
      permalink: 'deleteCompany',
      options: {
        title: 'Delete Company',
        actionLabel: 'Delete'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteCompanyModal)
  },
  async [LOAD_COMPANY] (context, companyUuid) {
    let company = await api.getCompany(companyUuid)
    context.commit(LOAD_COMPANY, company)
  },
  async [EDIT_COMPANY] (context, company) {
    let editCompanyModal = {
      permalink: 'editCompany',
      options: {
        title: 'Edit Company',
        actionLabel: 'Save'
      },
      params: {
        uuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editCompanyModal)
  },
  async [EDIT_MASTER_NOTE] (context, company) {
    let editMasterNoteModal = {
      permalink: 'editCompanyMasterNote',
      options: {
        title: 'Edit Master Note',
        actionLabel: 'Save'
      },
      params: {
        uuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editMasterNoteModal)
  },
  async [NEW_COMPANY_MANAGER] (context, company) {
    let newCompanyManagerModal = {
      permalink: 'newManager',
      options: {
        title: 'New Manager',
        actionLabel: 'Save'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, newCompanyManagerModal)
  },
  async [DELETE_COMPANY_MANAGER] (context, manager) {
    let deleteManagerModal = {
      permalink: 'deleteManager',
      options: {
        title: 'Delete Manager',
        actionLabel: 'Delete'
      },
      params: {
        companyUuid: manager.CompanyUuid,
        uuid: manager.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteManagerModal)
  },
  async [EDIT_COMPANY_MANAGER] (context, manager) {
    let editManagerModal = {
      permalink: 'editManager',
      options: {
        title: 'Edit Manager',
        actionLabel: 'Save'
      },
      params: {
        companyUuid: manager.CompanyUuid,
        uuid: manager.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editManagerModal)
  },
  async [GENERATE_ACCEPTANCE_RATE_REPORT] (context, manager) {
    let generateManagerAcceptanceRateReportModal = {
      permalink: 'generateManagerAcceptanceRateReport',
      options: {
        title: 'Generate Acceptance Rate Report',
        actionLabel: 'Generate'
      },
      params: {
        uuid: manager.uuid
      }
    }
    context.dispatch(OPEN_MODAL, generateManagerAcceptanceRateReportModal)
  },
  async [GENERATE_ALL_COMPANY_STATS] (context, payload) {
    let generateAllCompanyStatsModal = {
      permalink: 'generateAllCompanyStats',
      options: {
        title: 'Generate Stats for All Companies',
        actionLabel: 'Generate'
      },
      params: {
      }
    }
    context.dispatch(OPEN_MODAL, generateAllCompanyStatsModal)
  },
  async [VIEW_ALL_COMPANY_STATS] (context, payload) {
    let viewAllCompaniesStatsModal = {
      permalink: 'viewAllCompanyStats',
      options: {
        title: 'View Statistics from All Companies',
        actionLabel: 'Save'
      }
    }
    context.dispatch(OPEN_MODAL, viewAllCompaniesStatsModal)
  },

  async [EDIT_ACCEPTANCE_RATE_REPORT] (context, manager) {
    let editManagerAcceptanceRateReportModal = {
      permalink: 'editManagerAcceptanceRateReport',
      options: {
        title: 'Edit Acceptance Rate Report',
        actionLabel: 'Save'
      },
      params: {
        uuid: manager.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editManagerAcceptanceRateReportModal)
  },
  async [GENERATE_COMPANY_ACCEPTANCE_RATE_REPORT] (context, company) {
    let generateCompanyAcceptanceRateReportModal = {
      permalink: 'generateCompanyAcceptanceRateReport',
      options: {
        title: 'Generate Acceptance Rate Report',
        actionLabel: 'Generate'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, generateCompanyAcceptanceRateReportModal)
  },
  async [EDIT_COMPANY_ACCEPTANCE_RATE_REPORT] (context, company) {
    let editCompanyAcceptanceRateReportModal = {
      permalink: 'editCompanyAcceptanceRateReport',
      options: {
        title: 'Edit Acceptance Rate Report',
        actionLabel: 'Save'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editCompanyAcceptanceRateReportModal)
  },
  async [NEW_PROPERTY] (context, company) {
    let newPropertyModal = {
      permalink: 'newProperty',
      options: {
        title: 'New Property',
        actionLabel: 'Save'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, newPropertyModal)
  },
  async [NEW_PROPERTY_EXCEL] (context, company) {
    let newPropertyExcelModal = {
      permalink: 'newPropertyExcel',
      options: {
        title: 'New Property-Excel',
        actionLabel: 'Save'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, newPropertyExcelModal)
  },
  async [NEW_CONTRACTOR] (context, company) {
    let newContractorModal = {
      permalink: 'newContractor',
      options: {
        title: 'New Contractor',
        actionLabel: 'Save'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, newContractorModal)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/company.js